var beans = { Otter: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 10, A2: 0, A3: 0, A4: 0, A5: 4 }, Q2: { A1: 10, A2: 1, A3: 1, A4: 0 }, Q3: { A1: 0, A2: 10, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 4, A3: 1, A4: 4, A5: 1 }, Q5: { A1: 0, A2: 0, A3: 0, A4: 7, A5: 1 }, Q6: { A1: 2, A2: 5, A3: 23, A4: 10, A5: 29 } }, Shark: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 4, A3: 0, A4: 10, A5: 0 }, Q2: { A1: 3, A2: 7, A3: 0, A4: 0 }, Q3: { A1: 10, A2: 0, A3: 0, A4: 0, A5: 7 }, Q4: { A1: 0, A2: 0, A3: 0, A4: 10, A5: 10 }, Q5: { A1: 0, A2: 0, A3: 4, A4: 1, A5: 0 }, Q6: { A1: 15, A2: 32, A3: 2, A4: 25, A5: 6 } }, Octopus: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 1, A3: 3, A4: 7, A5: 1 }, Q2: { A1: 1, A2: 7, A3: 1, A4: 1 }, Q3: { A1: 3, A2: 0, A3: 7, A4: 0, A5: 3 }, Q4: { A1: 3, A2: 0, A3: 1, A4: 7, A5: 0 }, Q5: { A1: 3, A2: 7, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 6, A2: 31, A3: 12, A4: 26, A5: 32 } }, Lobster: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 7, A3: 0, A4: 7, A5: 1 }, Q2: { A1: 3, A2: 3, A3: 1, A4: 0 }, Q3: { A1: 0, A2: 10, A3: 1, A4: 4, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 10, A4: 3, A5: 0 }, Q5: { A1: 1, A2: 4, A3: 1, A4: 0, A5: 0 }, Q6: { A1: 16, A2: 30, A3: 16, A4: 16, A5: 1 } }, Clam: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 4, A3: 0, A4: 3, A5: 7 }, Q2: { A1: 3, A2: 7, A3: 1, A4: 0 }, Q3: { A1: 0, A2: 7, A3: 0, A4: 3, A5: 0 }, Q4: { A1: 1, A2: 0, A3: 0, A4: 1, A5: 7 }, Q5: { A1: 10, A2: 1, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 21, A2: 20, A3: 20, A4: 21, A5: 4 } }, Blobfish: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 3, A2: 3, A3: 0, A4: 0, A5: 1 }, Q2: { A1: 3, A2: 0, A3: 7, A4: 0 }, Q3: { A1: 0, A2: 1, A3: 10, A4: 0, A5: 1 }, Q4: { A1: 0, A2: 0, A3: 3, A4: 7, A5: 0 }, Q5: { A1: 0, A2: 10, A3: 0, A4: 0, A5: 4 }, Q6: { A1: 23, A2: 25, A3: 17, A4: 6, A5: 2 } }, Anglerfish: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 0, A4: 0, A5: 7 }, Q2: { A1: 1, A2: 0, A3: 3, A4: 7 }, Q3: { A1: 4, A2: 0, A3: 0, A4: 0, A5: 10 }, Q4: { A1: 0, A2: 0, A3: 0, A4: 10, A5: 4 }, Q5: { A1: 0, A2: 0, A3: 0, A4: 1, A5: 10 }, Q6: { A1: 22, A2: 28, A3: 21, A4: 5, A5: 5 } }, Axolotl: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 0, A4: 4, A5: 7 }, Q2: { A1: 3, A2: 0, A3: 0, A4: 7 }, Q3: { A1: 7, A2: 1, A3: 3, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 4, A4: 10, A5: 0 }, Q5: { A1: 1, A2: 7, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 17, A2: 29, A3: 14, A4: 29, A5: 7 } }, Turtle: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 4, A3: 0, A4: 10, A5: 0 }, Q2: { A1: 0, A2: 4, A3: 4, A4: 0 }, Q3: { A1: 1, A2: 0, A3: 4, A4: 7, A5: 0 }, Q4: { A1: 4, A2: 0, A3: 0, A4: 10, A5: 0 }, Q5: { A1: 3, A2: 1, A3: 1, A4: 1, A5: 0 }, Q6: { A1: 1, A2: 4, A3: 18, A4: 33, A5: 25 } }, Penguin: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 1, A4: 10, A5: 0 }, Q2: { A1: 0, A2: 0, A3: 1, A4: 10 }, Q3: { A1: 0, A2: 10, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 3, A4: 7, A5: 1 }, Q5: { A1: 1, A2: 0, A3: 7, A4: 0, A5: 0 }, Q6: { A1: 19, A2: 11, A3: 24, A4: 30, A5: 9 } }, Pufferfish: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 0, A4: 7, A5: 0 }, Q2: { A1: 4, A2: 0, A3: 0, A4: 4 }, Q3: { A1: 3, A2: 0, A3: 10, A4: 0, A5: 3 }, Q4: { A1: 4, A2: 0, A3: 0, A4: 4, A5: 1 }, Q5: { A1: 0, A2: 1, A3: 0, A4: 10, A5: 0 }, Q6: { A1: 5, A2: 1, A3: 11, A4: 27, A5: 26 } }, Sardines: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 7, A3: 0, A4: 4, A5: 1 }, Q2: { A1: 1, A2: 7, A3: 1, A4: 0 }, Q3: { A1: 0, A2: 7, A3: 3, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 3, A3: 4, A4: 0, A5: 1 }, Q5: { A1: 4, A2: 0, A3: 0, A4: 4, A5: 0 }, Q6: { A1: 14, A2: 26, A3: 10, A4: 28, A5: 8 } }, Sushi: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 7, A2: 10, A3: 0, A4: 0, A5: 0 }, Q2: { A1: 3, A2: 4, A3: 0, A4: 0 }, Q3: { A1: 3, A2: 4, A3: 1, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 3, A4: 4, A5: 1 }, Q5: { A1: 4, A2: 4, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 32, A2: 10, A3: 8, A4: 18, A5: 17 } }, Burger: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 7, A2: 1, A3: 0, A4: 3, A5: 1 }, Q2: { A1: 0, A2: 10, A3: 1, A4: 0 }, Q3: { A1: 3, A2: 0, A3: 7, A4: 0, A5: 0 }, Q4: { A1: 3, A2: 0, A3: 7, A4: 0, A5: 3 }, Q5: { A1: 4, A2: 0, A3: 4, A4: 0, A5: 0 }, Q6: { A1: 33, A2: 19, A3: 15, A4: 19, A5: 16 } }, Cheese: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 4, A2: 7, A3: 0, A4: 0, A5: 0 }, Q2: { A1: 0, A2: 0, A3: 4, A4: 10 }, Q3: { A1: 0, A2: 4, A3: 10, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 4, A4: 0, A5: 4 }, Q5: { A1: 4, A2: 0, A3: 1, A4: 3, A5: 0 }, Q6: { A1: 31, A2: 22, A3: 9, A4: 20, A5: 15 } }, Avocado: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 7, A3: 0, A4: 0, A5: 1 }, Q2: { A1: 0, A2: 4, A3: 3, A4: 0 }, Q3: { A1: 3, A2: 0, A3: 0, A4: 3, A5: 3 }, Q4: { A1: 0, A2: 4, A3: 7, A4: 0, A5: 0 }, Q5: { A1: 10, A2: 0, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 34, A2: 23, A3: 13, A4: 7, A5: 18 } }, Banana: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 0, A4: 4, A5: 0 }, Q2: { A1: 0, A2: 7, A3: 1, A4: 0 }, Q3: { A1: 1, A2: 7, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 3, A2: 7, A3: 1, A4: 0, A5: 0 }, Q5: { A1: 0, A2: 1, A3: 0, A4: 7, A5: 0 }, Q6: { A1: 30, A2: 24, A3: 7, A4: 8, A5: 20 } }, Watermelon: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 3, A3: 0, A4: 7, A5: 0 }, Q2: { A1: 0, A2: 10, A3: 0, A4: 0 }, Q3: { A1: 0, A2: 3, A3: 7, A4: 0, A5: 0 }, Q4: { A1: 4, A2: 1, A3: 0, A4: 3, A5: 0 }, Q5: { A1: 7, A2: 3, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 29, A2: 7, A3: 5, A4: 11, A5: 22 } }, Broccoli: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 7, A3: 3, A4: 0, A5: 0 }, Q2: { A1: 0, A2: 0, A3: 4, A4: 10 }, Q3: { A1: 0, A2: 0, A3: 0, A4: 7, A5: 4 }, Q4: { A1: 0, A2: 4, A3: 0, A4: 0, A5: 4 }, Q5: { A1: 1, A2: 3, A3: 0, A4: 0, A5: 7 }, Q6: { A1: 28, A2: 15, A3: 4, A4: 14, A5: 24 } }, Aubergine: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 7, A3: 0, A4: 0, A5: 1 }, Q2: { A1: 0, A2: 0, A3: 10, A4: 1 }, Q3: { A1: 0, A2: 7, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 10, A3: 1, A4: 0, A5: 1 }, Q5: { A1: 0, A2: 7, A3: 0, A4: 4, A5: 0 }, Q6: { A1: 27, A2: 14, A3: 3, A4: 15, A5: 23 } }, Lemon: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 1, A3: 0, A4: 7, A5: 0 }, Q2: { A1: 0, A2: 10, A3: 4, A4: 0 }, Q3: { A1: 4, A2: 1, A3: 1, A4: 0, A5: 1 }, Q4: { A1: 4, A2: 1, A3: 0, A4: 0, A5: 4 }, Q5: { A1: 7, A2: 1, A3: 1, A4: 0, A5: 0 }, Q6: { A1: 26, A2: 3, A3: 6, A4: 9, A5: 33 } }, Dinosaur: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 0, A3: 10, A4: 0, A5: 7 }, Q2: { A1: 4, A2: 4, A3: 0, A4: 0 }, Q3: { A1: 4, A2: 0, A3: 0, A4: 10, A5: 1 }, Q4: { A1: 1, A2: 3, A3: 10, A4: 0, A5: 0 }, Q5: { A1: 0, A2: 0, A3: 10, A4: 0, A5: 3 }, Q6: { A1: 11, A2: 34, A3: 1, A4: 23, A5: 19 } }, Hedgehog: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 0, A3: 7, A4: 0, A5: 7 }, Q2: { A1: 1, A2: 0, A3: 7, A4: 1 }, Q3: { A1: 0, A2: 1, A3: 3, A4: 4, A5: 0 }, Q4: { A1: 7, A2: 3, A3: 0, A4: 0, A5: 1 }, Q5: { A1: 0, A2: 0, A3: 1, A4: 0, A5: 10 }, Q6: { A1: 8, A2: 8, A3: 29, A4: 31, A5: 11 } }, Sloth: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 0, A3: 0, A4: 1, A5: 10 }, Q2: { A1: 1, A2: 0, A3: 4, A4: 3 }, Q3: { A1: 0, A2: 0, A3: 4, A4: 7, A5: 0 }, Q4: { A1: 4, A2: 0, A3: 4, A4: 0, A5: 1 }, Q5: { A1: 0, A2: 0, A3: 3, A4: 0, A5: 10 }, Q6: { A1: 18, A2: 2, A3: 19, A4: 34, A5: 3 } }, RedPanda: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 3, A3: 0, A4: 0, A5: 7 }, Q2: { A1: 1, A2: 4, A3: 3, A4: 0 }, Q3: { A1: 1, A2: 3, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 10, A2: 0, A3: 0, A4: 1, A5: 0 }, Q5: { A1: 4, A2: 4, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 20, A2: 17, A3: 32, A4: 17, A5: 13 } }, Dog: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 1, A3: 1, A4: 4, A5: 10 }, Q2: { A1: 4, A2: 4, A3: 0, A4: 0 }, Q3: { A1: 4, A2: 4, A3: 4, A4: 0, A5: 0 }, Q4: { A1: 10, A2: 1, A3: 1, A4: 0, A5: 1 }, Q5: { A1: 7, A2: 1, A3: 3, A4: 0, A5: 0 }, Q6: { A1: 13, A2: 27, A3: 34, A4: 12, A5: 12 } }, Koala: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 1, A2: 3, A3: 0, A4: 1, A5: 3 }, Q2: { A1: 1, A2: 7, A3: 0, A4: 0 }, Q3: { A1: 0, A2: 1, A3: 1, A4: 1, A5: 4 }, Q4: { A1: 10, A2: 0, A3: 0, A4: 1, A5: 0 }, Q5: { A1: 0, A2: 4, A3: 0, A4: 4, A5: 0 }, Q6: { A1: 9, A2: 21, A3: 27, A4: 32, A5: 10 } }, Frog: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 7, A3: 0, A4: 0, A5: 3 }, Q2: { A1: 10, A2: 0, A3: 3, A4: 0 }, Q3: { A1: 0, A2: 7, A3: 3, A4: 1, A5: 0 }, Q4: { A1: 4, A2: 3, A3: 0, A4: 3, A5: 0 }, Q5: { A1: 1, A2: 1, A3: 4, A4: 1, A5: 0 }, Q6: { A1: 10, A2: 33, A3: 22, A4: 1, A5: 28 } }, Duck: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 4, A3: 0, A4: 0, A5: 3 }, Q2: { A1: 4, A2: 0, A3: 3, A4: 3 }, Q3: { A1: 3, A2: 3, A3: 3, A4: 0, A5: 0 }, Q4: { A1: 0, A2: 1, A3: 7, A4: 0, A5: 3 }, Q5: { A1: 7, A2: 3, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 25, A2: 18, A3: 28, A4: 4, A5: 27 } }, Mole: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 0, A3: 7, A4: 0, A5: 7 }, Q2: { A1: 7, A2: 0, A3: 4, A4: 0 }, Q3: { A1: 0, A2: 1, A3: 4, A4: 3, A5: 0 }, Q4: { A1: 4, A2: 4, A3: 0, A4: 0, A5: 0 }, Q5: { A1: 0, A2: 0, A3: 1, A4: 0, A5: 10 }, Q6: { A1: 7, A2: 9, A3: 25, A4: 22, A5: 34 } }, Chicken: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 4, A3: 0, A4: 0, A5: 3 }, Q2: { A1: 10, A2: 1, A3: 0, A4: 0 }, Q3: { A1: 0, A2: 0, A3: 7, A4: 4, A5: 0 }, Q4: { A1: 0, A2: 3, A3: 7, A4: 0, A5: 0 }, Q5: { A1: 0, A2: 7, A3: 3, A4: 0, A5: 0 }, Q6: { A1: 24, A2: 6, A3: 26, A4: 13, A5: 31 } }, Camera: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 0, A3: 10, A4: 4, A5: 0 }, Q2: { A1: 0, A2: 7, A3: 0, A4: 3 }, Q3: { A1: 10, A2: 0, A3: 0, A4: 3, A5: 0 }, Q4: { A1: 0, A2: 0, A3: 0, A4: 3, A5: 10 }, Q5: { A1: 7, A2: 4, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 12, A2: 13, A3: 31, A4: 2, A5: 30 } }, Toadstool: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 1, A3: 4, A4: 0, A5: 4 }, Q2: { A1: 4, A2: 0, A3: 4, A4: 0 }, Q3: { A1: 0, A2: 0, A3: 3, A4: 3, A5: 3 }, Q4: { A1: 0, A2: 4, A3: 3, A4: 0, A5: 3 }, Q5: { A1: 4, A2: 0, A3: 4, A4: 0, A5: 0 }, Q6: { A1: 3, A2: 12, A3: 33, A4: 24, A5: 14 } }, Rainbow: { score: 0, pre6: 0, sixScore: 0, Q1: { A1: 0, A2: 1, A3: 4, A4: 4, A5: 0 }, Q2: { A1: 1, A2: 10, A3: 1, A4: 0 }, Q3: { A1: 3, A2: 3, A3: 3, A4: 0, A5: 0 }, Q4: { A1: 7, A2: 0, A3: 1, A4: 3, A5: 0 }, Q5: { A1: 7, A2: 3, A3: 0, A4: 0, A5: 0 }, Q6: { A1: 4, A2: 16, A3: 30, A4: 3, A5: 21 } } };

document.addEventListener('DOMContentLoaded', function () {
    let params = new URLSearchParams(document.location.search);
    let chosenBean = params.get("silly-bean");
    if(chosenBean != null){
        let answerDiv = document.getElementById("answer-div");
        let openingDiv = document.getElementById("question-0");
        let beanDiv = document.querySelector('[bean-name="' + chosenBean +'"]')
        if(answerDiv && openingDiv && beanDiv){
            beanDiv.classList.remove("hidden");
            answerDiv.classList.remove("hidden");
            openingDiv.classList.add("hidden");
            document.querySelector(".clouds-container").classList.remove("hidden");
        }
    }
    else{
        // const circles = document.querySelectorAll(".opening-circle");
        // let windowWidth = window.innerWidth;
        // var increment = 1
        // if (windowWidth < 500){
        //     var max = 8
        // }
        // else if (windowWidth < 640){
        //     var max = 12
        // }
        // else if (windowWidth < 900){
        //     var max = 28
        //     var increment = 2
        // }
        // else{
        //     var max = 34
        //     var increment = 2
        // }
        // console.log(windowWidth)
        // console.log(increment);
        // for (let i = 0; i < circles.length; i++) {
        //     let currentOrder = circles[i].style.getPropertyValue('order');
        //     console.log(circles[i])
        //     console.log(currentOrder)
        //     console.log(Number(currentOrder) + increment)
        //     console.log(circles[i])
        //     var newNumber = Number(currentOrder) + increment;
        //     if(newNumber > max){
        //         newNumber = newNumber - max;
        //     }
        //     circles[i].style.order = newNumber;
        // }
    }

    const answers = document.querySelectorAll(".quiz-button");
    const nextButtons = document.querySelectorAll(".next-button");
    const backButtons = document.querySelectorAll(".back-button");
    for (let i = 0; i < answers.length; i++) {
        answers[i].addEventListener('click', function (e) {
            answerClick(e);
        });
    }
    for (let i = 0; i < nextButtons.length; i++) {
        nextButtons[i].addEventListener('click', function (e) {
            changePage(e, "next");
        });
    }
    for (let i = 0; i < backButtons.length; i++) {
        backButtons[i].addEventListener('click', function (e) {
            changePage(e, "back");
        });
    }
    const submitButton = document.getElementById("get-bean");
    if (submitButton) {
        submitButton.addEventListener('click', function () {
            calculateBean();
        });
    }
});

function answerClick(event) {
    let selectedAnswer = event.target.closest(".quiz-button");
    if (selectedAnswer) {
        selectedAnswer.setAttribute('selected', true);
        let questionDiv = event.target.closest(".question-div");
        let questionAnswers = questionDiv.querySelectorAll(".quiz-button");
        for (let a = 0; a < questionAnswers.length; a++) {
            if (questionAnswers[a] != selectedAnswer) {
                questionAnswers[a].removeAttribute('selected');
            }
        }
        if(questionDiv.querySelector(".next-button")){
            questionDiv.querySelector(".next-button").disabled = false;
        }
        if(questionDiv.querySelector(".submit-button")){
            questionDiv.querySelector(".submit-button").disabled = false;
        }
        if(questionDiv.querySelector(".button-div")){
            questionDiv.querySelector(".button-div").classList.remove("none-selected");
        }

    }
}
function calculateBean() {
    const thisBeans = beans;
    const selected1 = document.getElementById("question-1").querySelector(".quiz-button[selected=true]");
    if (selected1) {
        const answer1Id = selected1.id;
        var answer1 = answer1Id.replace("Q1-", "");
    }
    const selected2 = document.getElementById("question-2").querySelector(".quiz-button[selected=true]");
    if (selected2) {
        const answer2Id = selected2.id;
        var answer2 = answer2Id.replace("Q2-", "");
    }
    const selected3 = document.getElementById("question-3").querySelector(".quiz-button[selected=true]");
    if (selected3) {
        const answer3Id = selected3.id;
        var answer3 = answer3Id.replace("Q3-", "");
    }
    const selected4 = document.getElementById("question-4").querySelector(".quiz-button[selected=true]");
    if (selected4) {
        const answer1Id = selected4.id;
        var answer4 = answer1Id.replace("Q4-", "");
    }
    const selected5 = document.getElementById("question-5").querySelector(".quiz-button[selected=true]");
    if (selected5) {
        const answer5Id = selected5.id;
        var answer5 = answer5Id.replace("Q5-", "");
    }
    const selected6 = document.getElementById("question-6").querySelector(".quiz-button[selected=true]");
    if (selected6) {
        const answer6Id = selected6.id;
        var answer6 = answer6Id.replace("Q6-", "");
    }
    if(selected6){
        if (answer1 && answer2 && answer3 && answer4 && answer5 && answer6) {
            for (const bean in thisBeans) {
                let pre6score = 0
                pre6score = thisBeans[bean]["Q1"][answer1] + thisBeans[bean]["Q2"][answer2] + thisBeans[bean]["Q3"][answer3] + thisBeans[bean]["Q4"][answer4] + thisBeans[bean]["Q5"][answer5];
                thisBeans[bean]["pre6"] = pre6score;
                thisBeans[bean]["sixScore"] = thisBeans[bean]["Q6"][answer6];
            }
        }
        const pre6Sorted = Object.fromEntries(
            Object.entries(thisBeans).sort(([, a], [, b]) => b.pre6 - a.pre6)
        );
        let prevScore = 0;
        let uniqueScores = 0;
        let top7 = {};
        for (const bean in pre6Sorted) {
            if (pre6Sorted[bean]["pre6"] != prevScore) {
                prevScore = pre6Sorted[bean]["pre6"];
                uniqueScores++;
                if(uniqueScores >= 8){
                    break;
                }
                else{
                    top7[bean]= pre6Sorted[bean];
                }
            }
            else{
             top7[bean]= pre6Sorted[bean];
            }
        };
        const top7Sorted = Object.fromEntries(
            Object.entries(top7).sort(([, a], [, b]) => b.sixScore - a.sixScore)
        );
        let sixBeanScoring = [10,8,6,4,3,2,1];
        let index = 0;
        for (const bean in top7Sorted) {
            if (index <= 6){
                top7Sorted[bean]["score"] = top7Sorted[bean]["pre6"] + sixBeanScoring[index];
                index++
            }
            else {
                top7Sorted[bean]["score"] = top7Sorted[bean]["pre6"];
            }
        };
        const finalSort = Object.fromEntries(
            Object.entries(top7Sorted).sort(([, a], [, b]) => b.score - a.score)
        );
        var topanswers = {};
        var topScore = 0;
        for (const bean in finalSort) {
            if (topScore == 0){
                var chosenBean = bean;
                var topScore = finalSort[bean]["score"];
                topanswers[bean] = finalSort[bean];
            }
            else{
                if(topScore == finalSort[bean]["score"]){
                    topanswers[bean] = finalSort[bean];
                }
                else{
                    break;
                }
            } 
        };
        var numTopAnswers = Object.keys(topanswers).length;
        if (numTopAnswers != 1){
            const tieSort = Object.fromEntries(
                Object.entries(topanswers).sort(([, a], [, b]) => b.pre6 - a.pre6)
            );
            for (const bean in tieSort) {
                var chosenBean = bean;
                break;
            };
        }
        document.getElementById(chosenBean).classList.remove("hidden");
        for (const bean in beans) {
            beans[bean]["score"] = 0;
            beans[bean]["pre6"] = 0;
            beans[bean]["sixScore"] = 0;
        };
        if(document.getElementById(chosenBean)){
            const url = new URL(location);
            var name = document.getElementById(chosenBean).getAttribute("bean-name");
            url.searchParams.set("silly-bean", name);
            history.pushState({}, "", url);
        }
        document.getElementById('question-6').classList.add("hidden");
        document.getElementById('answer-div').classList.remove("hidden");
    }
    else{
        // require answer
    }
}
function changePage(event, direction){
    let thisQuestionDiv = event.target.closest(".question-div");
    if(thisQuestionDiv){
        let thisQuestion = thisQuestionDiv.getAttribute('id').replace("question-", "");
        let questionNumber = Number(thisQuestion);
        let newQNumber = questionNumber;
        let ready = true;
        if(questionNumber != null && direction == "next"){
            newQNumber = questionNumber + 1;
            let selectedAnswer = thisQuestionDiv.querySelector(".quiz-button[selected=true]");
            if(!selectedAnswer && questionNumber != 0){
                ready = false;
            }
        }
        else if(questionNumber && direction == "back"){
            newQNumber = questionNumber - 1;
        }
        let newQuestionDiv = document.getElementById("question-" + newQNumber);
        if(newQuestionDiv && ready){
            thisQuestionDiv.classList.add("hidden");
            newQuestionDiv.classList.remove("hidden");
            if(newQNumber == 1){
                document.querySelector(".clouds-container").classList.remove("hidden");
            }
        }
    
    };
};